/**
 * questionGroup接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const questionGroup = {
  getQuestionGroups (params) {
    return axios.get('/api/questionGroup/GetQuestionGroups', { params })
  },
  getQuestionGroup (params) {
    return axios.get('/api/questionGroup/GetQuestionGroup', { params })
  },
  editQuestionGroup (params) {
    return axios.post('/api/questionGroup/EditQuestionGroup', params)
  },
  deleteQuestionGroup (params) {
    return axios.delete('/api/questionGroup/DeleteQuestionGroup', { params })
  }
}

export default questionGroup
